import styled, { css } from "styled-components"
import React from "react"
import { desktopTextStyles, FontFamilyRegular } from "../typography.styles"
import Breakpoints from "../breakpoints"

const GridItem = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: span ${props => props.colSpan};
  }
`

const GridLabel = styled.label`
  ${desktopTextStyles.HeadingSixRegular}
  line-height: 14px;
  font-size: 12px;
  margin-bottom: 12px;
  margin-left: 10px;

  ::before {
    content: "*";
    color: #ca3232;
    margin-right: 8px;
  }
`

const ErrorMessage = styled.p`
  ${FontFamilyRegular}
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */
  padding: 8px 12px;

  color: #ca3232;
`

const InputStyle = css`
  width: 100%;
  box-sizing: border-box;
  background: var(--white);
  border: 1px solid ${props => (props.error ? "#CA3232" : "#cccccc80")};
  ${desktopTextStyles.FooterBodyText}
  line-height: 17px;
  color: #323232;
  padding: 16px 12px;

  ::placeholder {
    color: #32323280;
  }

  :focus,
  :active {
    outline: none;
  }

  ${props =>
    props.disabled &&
    css`
      opacity: 0.5;
    `}
`

const FormInput = ({
  inputTitle,
  placeholder,
  error,
  errors,
  id,
  as,
  disabled,
  handler,
  value,
  name,
  colSpan = 1,
  children,
}) => {
  const errorMessage = error || errors[name]?.message

  return (
    <GridItem colSpan={colSpan}>
      <GridLabel htmlFor={id}>{inputTitle}</GridLabel>
      <FormInput.Input
        as={as}
        disabled={disabled}
        name={name}
        id={id}
        type="text"
        placeholder={placeholder ?? inputTitle}
        ref={handler}
        value={value}
        error={errorMessage}
      >
        {children}
      </FormInput.Input>
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </GridItem>
  )
}

FormInput.Input = styled.input`
  ${InputStyle}
`

FormInput.Textarea = styled.textarea`
  ${InputStyle}
  resize: none;
  height: 8rem;
`

FormInput.Select = styled.select`
  display: block;
  -webkit-appearance: none;

  background-image: url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PScwIDAgMTEgMTMnIGZpbGw9J25vbmUnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+PHBhdGggdHJhbnNmb3JtPSdyb3RhdGUoOTApIHRyYW5zbGF0ZSgtMC45IC0xMi4zKScgZD0nTTIuMjIzOTMgMTEuMTU1OEwwLjQ4Mzk4MiAxMi44NjVMMy45NzU5NyAxMi44NjVMMTAuMDg0IDYuODY0OTlMMy45NzU5NyAwLjg2NDk5TDAuNDgzOTgzIDAuODY0OTg5TDYuNTkyIDYuODY0OTlMMi4yMjM5MyAxMS4xNTU4WicgZmlsbD0nIzRhNGU1NycvPjwvc3ZnPgo=");
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: top 50% right 1em;
  cursor: pointer;
`

export default FormInput
